import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e4bacb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fw-bold mb-3 text-center d-flex justify-content-center title pt-5" }
const _hoisted_2 = { class: "row container mb-5 shadow-lg bg-white p-3 p-lg-5 rounded-4 mx-auto" }
const _hoisted_3 = { class: "title-form fw-bold text-center pb-5 fs-6" }
const _hoisted_4 = { class: "information-container" }
const _hoisted_5 = { class: "d-flex justify-content-center pb-4" }
const _hoisted_6 = { class: "col-sm-3 fw-bold col-4" }
const _hoisted_7 = { class: "col-sm-3 col-4" }
const _hoisted_8 = { class: "col-sm-6 col-4" }
const _hoisted_9 = { class: "d-flex justify-content-center pb-4" }
const _hoisted_10 = { class: "col-sm-3 fw-bold col-4" }
const _hoisted_11 = { class: "col-sm-3 col-4" }
const _hoisted_12 = { class: "col-sm-6 col-4" }
const _hoisted_13 = { class: "d-flex justify-content-center pb-4" }
const _hoisted_14 = { class: "col-3 fw-bold" }
const _hoisted_15 = { class: "col-9" }
const _hoisted_16 = { class: "d-sm-flex justify-content-center" }
const _hoisted_17 = { class: "col-sm-3 fw-bold" }
const _hoisted_18 = { class: "col-sm-9 text-break" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = { class: "d-flex justify-content-center pb-4" }
const _hoisted_21 = { class: "col-3 fw-bold" }
const _hoisted_22 = { class: "col-9" }
const _hoisted_23 = { class: "bg-white shadow rounded-4 p-3 p-lg-5 mb-5 container" }
const _hoisted_24 = { class: "fw-bold text-center mb-3 mb-lg-5 fs-6" }
const _hoisted_25 = { class: "mb-3 text-break while-spaces term-of-use" }
const _hoisted_26 = { class: "checkbox-wrapper d-flex justify-content-center align-items-center" }
const _hoisted_27 = ["for"]
const _hoisted_28 = ["id"]
const _hoisted_29 = {
  key: 0,
  class: "text-danger text-center"
}
const _hoisted_30 = { class: "d-flex justify-content-center pb-5" }

import Button from '@/components/button/index.vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { USER_STORE } from '@/store/constants'
import ErrorMessage from '@/components/error-message'
import { translate } from '@/languages/i18n'
import { watchEffect, computed, ref } from 'vue'
import { getMessage } from '@/constants/messageCode.ts'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const joinUsersData = computed(() => store.getters[USER_STORE.GETTERS.JOIN_USER_VALUE])

const invitedCommunity = computed(() => store.getters[USER_STORE.GETTERS.INVITE_COMMUNITY])
const termsCommunity = computed(() => store.getters[USER_STORE.GETTERS.TERMS_COMMUNITY])
const router = useRouter()
const disableBtn2 = ref(true)
const formData = ref(joinUsersData)
const checkSubmitSecond = ref(false)
// 2022/10/19 PhuongTT Show invalid URL message UAT#4632: SB23 (Ph2-R20221021)
// const registerFailed = localStorage.getItem('registerFailed')
// const userParticipant = localStorage.getItem('userParticipant')
// const userMax = localStorage.getItem('userMax')

const messageCode = localStorage.getItem('validateComunity')

watchEffect(() => {
  localStorage.removeItem('checkSubmit')

  if (formData.value.consent_of_community) disableBtn2.value = false
  else disableBtn2.value = true
})

const transitConfirm = () => {
  checkSubmitSecond.value = true
  store.dispatch(USER_STORE.ACTIONS.SET_JOIN_USER_VALUE, { ...formData.value, consent_of_community: true })
  //     2022/10/20 PhuongTT Show invalid URL message UAT#4632: SB23 (Ph2-R20221021)
  if (formData.value.consent_of_community) {
    router.push('/community/join_users_confirm')
    localStorage.removeItem('validateComunity')
  }
  // if (invitedCommunity.value?.admin) {
  //   if (formData.value.consent_of_community) {
  //     router.push('/community/join_users_confirm')
  //     localStorage.removeItem('registerFailed')
  //     localStorage.removeItem('userParticipant')
  //     localStorage.removeItem('userMax')
  //   }
  // } else {
  //   if (formData.value.consent_of_community) {
  //     router.push('/community/join_users_confirm')
  //     localStorage.removeItem('userParticipant')
  //     localStorage.removeItem('registerFailed')
  //     localStorage.removeItem('userMax')
  //   }
  // }
  localStorage.setItem('checkConfirm', true)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", null, _toDisplayString(_unref(invitedCommunity)?.corporation_name) + " " + _toDisplayString(_unref(invitedCommunity)?.community_name) + " " + _toDisplayString(_unref(translate)('SB23heading')), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(translate)('SB23title')), 1),
      (!_unref(invitedCommunity)?.community_id)
        ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
            key: 0,
            title: _unref(translate)('INVALID_URL_ERROR')
          }, null, 8, ["title"]))
        : _createCommentVNode("", true),
      (_unref(messageCode))
        ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
            key: 1,
            title: _unref(getMessage)(_unref(messageCode))
          }, null, 8, ["title"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(translate)('nameKanji')), 1),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(invitedCommunity)?.user?.family_name), 1),
          _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(invitedCommunity)?.user?.given_name), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(translate)('nameKatakana')), 1),
          _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(invitedCommunity)?.user?.family_name_kana), 1),
          _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(invitedCommunity)?.user?.given_name_kana), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(translate)('SB20belong')), 1),
          _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(invitedCommunity)?.department_name), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("p", _hoisted_17, _toDisplayString(_unref(translate)('email')), 1),
          _createElementVNode("p", _hoisted_18, [
            _createTextVNode(_toDisplayString(_unref(invitedCommunity)?.email), 1),
            _hoisted_19,
            _createTextVNode(" " + _toDisplayString(_unref(translate)('SB20noticeMail')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(translate)('dateOfBirth')), 1),
          _createElementVNode("p", _hoisted_22, _toDisplayString(_unref(invitedCommunity)?.user?.birthday), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("h1", _hoisted_24, _toDisplayString(_unref(invitedCommunity)?.community_name) + _toDisplayString(_unref(translate)('agreeLeaderShipSB20')), 1),
      _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(termsCommunity)?.term_of_service), 1),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("label", {
          for: _ctx.agreeConfirm,
          class: "mt-1 ms-2"
        }, [
          _withDirectives(_createElementVNode("input", {
            id: _ctx.agreeConfirm,
            type: "checkbox",
            class: "mr-1 cursor-pointer form-check-input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.consent_of_community) = $event))
          }, null, 8, _hoisted_28), [
            [_vModelCheckbox, formData.value.consent_of_community]
          ]),
          _createTextVNode(" " + _toDisplayString(_unref(invitedCommunity)?.community_name) + _toDisplayString(_unref(translate)('agreeLeaderShip')), 1)
        ], 8, _hoisted_27)
      ]),
      (!formData.value.consent_of_community && checkSubmitSecond.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_unref(invitedCommunity)?.community_name) + _toDisplayString(_unref(translate)('SA20communityError')), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createVNode(Button, {
        title: _unref(translate)('confirm'),
        type: 'secondary',
        onClick: transitConfirm,
        disabled: disableBtn2.value
      }, null, 8, ["title", "disabled"])
    ])
  ], 32))
}
}

})